import Icon from '@/components/ui/AppIcon';

interface SearchBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

const SearchBar = ({ searchTerm, onSearchChange }: SearchBarProps) => {
  return (
    <div className="relative">
      <Icon
        name="MagnifyingGlassIcon"
        size={20}
        className="absolute left-4 top-1/2 transform -translate-y-1/2 text-muted-foreground"
      />
      <input
        type="text"
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Search by common or scientific name..."
        className="w-full pl-12 pr-4 py-3 bg-card border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-foreground placeholder:text-muted-foreground"
      />
    </div>
  );
};

export default SearchBar;